import classNames from 'classnames';
import styles from '../supreme/track-list-supreme.module.css';

export function TrackCountColumn({ trackCount }: { trackCount: number }) {
    return <div className={classNames(styles['track-list__counter'])}>{trackCount}</div>;
}
